import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import SocialButton from './social-button';
import {
  SHOW_FIRST_N_SOCIAL_PROVIDERS_ON_MAIN_PAGE,
  getSocialProvidersConfigList,
} from '../core/social-providers';

import EmailPane from './email-pane';
import TermsAndConditions from './basic/terms-and-conditions';
import Header from './basic/header';
import MoreProviders from './more-providers';
import { translate } from '~/services/translate';
import { MOBILE_THRESHOLD } from '../core/constants';
import { ColumnFlex } from '~/components/basic/containers';
import OrSeparator from '~/components/basic/or-separator';

const MoreOptions = styled.div`
  font-size: 13px;
  line-height: 20px;
  margin: 8px auto 16px;
  color: ${({ theme }) => theme.lightBlue};
  cursor: pointer;

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    line-height:48px;
    margin: 0 auto 8px;
  }
`;

const ExtrasContainer = styled(ColumnFlex)`
  height: 56px;
  padding-top: 8px;
  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    padding-top: 0;
  }
`;

const ResetPasswordLink = styled.div`
  font-size: 13px;
  line-height: 20px;
  display: flex;
  margin: 0 auto auto auto;
  color: ${({ theme }) => theme.lightBlue};
  cursor: pointer;

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    line-height: 48px;
  }
`;

const AuthProvidersPane = ({ switchToResetPassword, isSignUp }) => {
  const [shouldRenderProviders, setShouldRenderProviders] = useState(true);
  const [showMoreProvidersDialog, setsShowMoreProvidersDialog] = useState(false);

  const hideMoreProviders = () => {
    setsShowMoreProvidersDialog(false);
  }

  const showMoreProviders = () => {
    setsShowMoreProvidersDialog(true);
  }

  const shouldHideProvidersSelection = shouldHide => {
    setShouldRenderProviders(!shouldHide);
  }

  const socialProvidersConfigList = getSocialProvidersConfigList();

  return (
    <ColumnFlex>
      <Header isSignUp={isSignUp} />
      {showMoreProvidersDialog && <MoreProviders onHide={hideMoreProviders} isSignUp={isSignUp} />}
      {shouldRenderProviders &&
        <>
          {socialProvidersConfigList.slice(0, SHOW_FIRST_N_SOCIAL_PROVIDERS_ON_MAIN_PAGE).map(provider => (
            <SocialButton
              data-test-id={`social-${provider.name}`}
              key={provider.name}
              backgroundColor={provider.backgroundColor}
              backgroundColorHover={provider.backgroundColorHover}
              Icon={provider.Icon}
              text={provider.text}
              connectionName={provider.connectionName}
              iconColor={provider.iconColor}
            />
          ))}
          {socialProvidersConfigList.length > SHOW_FIRST_N_SOCIAL_PROVIDERS_ON_MAIN_PAGE &&
            <MoreOptions
              data-test-id="button-more-options"
              onClick={showMoreProviders}
            >{translate('more_options')}
            </MoreOptions>
          }
          <OrSeparator />
        </>
      }
      <EmailPane
        shouldHideProviders={shouldHideProvidersSelection}
        isSignUp={isSignUp}
      />
      <ExtrasContainer>
        {isSignUp && <TermsAndConditions />}
        {!isSignUp && shouldRenderProviders &&
          <ResetPasswordLink onClick={switchToResetPassword}>
            {translate('reset_password_link')}
          </ResetPasswordLink>
        }
      </ExtrasContainer>
    </ColumnFlex>
  );
}

AuthProvidersPane.propTypes = {
  switchToResetPassword: PropTypes.func,
  isSignUp: PropTypes.bool,
}

export default AuthProvidersPane;